import { extendTailwindMerge } from "tailwind-merge";

const stiqTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom font sizes and line heights
      "font-size": [
        // Desktop typography
        "text-desktop-h1",
        "text-desktop-h2",
        "text-desktop-h3",
        "text-desktop-h4",
        "text-desktop-h5",
        "text-desktop-b1",
        "text-desktop-b2",
        "text-desktop-b3",
        "text-desktop-b4",
        "text-desktop-b5",

        // Tablet typography
        "text-tablet-h1",
        "text-tablet-h2",
        "text-tablet-h3",
        "text-tablet-h4",
        "text-tablet-h5",
        "text-tablet-b1",
        "text-tablet-b2",
        "text-tablet-b3",
        "text-tablet-b4",
        "text-tablet-b5",

        // Mobile typography
        "text-mobile-h1",
        "text-mobile-h2",
        "text-mobile-h3",
        "text-mobile-h4",
        "text-mobile-h5",
        "text-mobile-b1",
        "text-mobile-b2",
        "text-mobile-b3",
        "text-mobile-b4",
        "text-mobile-b5",

        // Custom sizes
        "text-xxs",
      ],

      // Custom line heights
      leading: [
        // Desktop line heights
        "leading-desktop-h1",
        "leading-desktop-h2",
        "leading-desktop-h3",
        "leading-desktop-h4",
        "leading-desktop-h5",
        "leading-desktop-b1",
        "leading-desktop-b1-tight",
        "leading-desktop-b2",
        "leading-desktop-b2-tight",
        "leading-desktop-b3",
        "leading-desktop-b3-tight",
        "leading-desktop-b4",
        "leading-desktop-b4-tight",
        "leading-desktop-b5",
        "leading-desktop-b5-tight",

        // Tablet line heights
        "leading-tablet-h1",
        "leading-tablet-h2",
        "leading-tablet-h3",
        "leading-tablet-h4",
        "leading-tablet-h5",
        "leading-tablet-b1",
        "leading-tablet-b1-tight",
        "leading-tablet-b2",
        "leading-tablet-b2-tight",
        "leading-tablet-b3",
        "leading-tablet-b3-tight",
        "leading-tablet-b4",
        "leading-tablet-b4-tight",
        "leading-tablet-b5",
        "leading-tablet-b5-tight",

        // Mobile line heights
        "leading-mobile-h1",
        "leading-mobile-h2",
        "leading-mobile-h3",
        "leading-mobile-h4",
        "leading-mobile-h5",
        "leading-mobile-b1",
        "leading-mobile-b1-tight",
        "leading-mobile-b2",
        "leading-mobile-b2-tight",
        "leading-mobile-b3",
        "leading-mobile-b3-tight",
        "leading-mobile-b4",
        "leading-mobile-b4-tight",
        "leading-mobile-b5",
        "leading-mobile-b5-tight",
      ],

      // Custom text colors
      "text-color": [
        // Primary colors
        "text-primary",
        "text-primary-weak",
        "text-primary-strong",
        "text-primary-foreground",

        // Secondary colors
        "text-secondary",
        "text-secondary-weak",
        "text-secondary-strong",
        "text-secondary-foreground",

        // Tertiary colors
        "text-tertiary",
        "text-tertiary-weak",
        "text-tertiary-strong",
        "text-tertiary-foreground",

        // Grayscale colors
        "text-grayscale",
        "text-grayscale-weak",
        "text-grayscale-label",
        "text-grayscale-input",
        "text-grayscale-placeholder",
        "text-grayscale-body",
        "text-grayscale-header",
        "text-grayscale-header-weak",
        "text-grayscale-line",

        // Status colors
        "text-success",
        "text-success-strong",
        "text-success-weak",
        "text-warning",
        "text-warning-strong",
        "text-warning-weak",
        "text-danger",
        "text-danger-strong",
        "text-danger-weak",

        // Social & Brand colors
        "text-linkedin",
        "text-footer-bg",
        "text-header-weak",

        // Course package colors
        "text-course-package-platinum",
        "text-course-package-gold",
        "text-course-package-silver",

        // Course card colors
        "text-course-card-discount-badge",
        "text-course-card-discount-badge-before",
      ],

      // Custom background colors
      "bg-color": [
        // Primary backgrounds
        "bg-primary",
        "bg-primary-weak",
        "bg-primary-strong",
        "bg-primary-foreground",
        "bg-primary-bg",
        "bg-primary-bg-strong",

        // Secondary backgrounds
        "bg-secondary",
        "bg-secondary-weak",
        "bg-secondary-strong",
        "bg-secondary-foreground",
        "bg-secondary-bg",
        "bg-secondary-bg-strong",

        // Tertiary backgrounds
        "bg-tertiary",
        "bg-tertiary-weak",
        "bg-tertiary-strong",
        "bg-tertiary-foreground",
        "bg-tertiary-bg",
        "bg-tertiary-bg-strong",

        // Grayscale backgrounds
        "bg-grayscale",
        "bg-grayscale-weak",
        "bg-grayscale-label",
        "bg-grayscale-input",
        "bg-grayscale-placeholder",
        "bg-grayscale-body",
        "bg-grayscale-header-weak",
        "bg-grayscale-line",

        // Status backgrounds
        "bg-success",
        "bg-success-strong",
        "bg-success-weak",
        "bg-success-bg",
        "bg-success-bg-strong",
        "bg-warning",
        "bg-warning-strong",
        "bg-warning-weak",
        "bg-warning-bg",
        "bg-warning-bg-strong",
        "bg-danger",
        "bg-danger-strong",
        "bg-danger-weak",
        "bg-danger-bg",
        "bg-danger-bg-strong",

        // Social & Brand backgrounds
        "bg-linkedin",
        "bg-footer-bg",
        "bg-header-weak",

        // Course package backgrounds
        "bg-course-package-platinum",
        "bg-course-package-gold",
        "bg-course-package-silver",

        // Course card backgrounds
        "bg-course-card-discount-badge",
        "bg-course-card-discount-badge-before",

        // Gradient backgrounds
        "bg-gradient-theme-orange",
        "bg-gradient-theme-green",
        "bg-gradient-theme-purple",
        "bg-gradient-youtube-diamond-badge",
        "bg-gradient-youtube-gold-badge",
        "bg-gradient-youtube-silver-badge",
      ],

      // Custom border colors
      "border-color": [
        // Primary borders
        "border-primary",
        "border-primary-weak",
        "border-primary-strong",
        "border-primary-foreground",
        "border-primary-bg",
        "border-bg-strong",

        // Secondary borders
        "border-secondary",
        "border-secondary-weak",
        "border-secondary-strong",
        "border-secondary-foreground",
        "border-secondary-bg",
        "border-secondary-bg-strong",

        // Tertiary borders
        "border-tertiary",
        "border-tertiary-weak",
        "border-tertiary-strong",
        "border-tertiary-foreground",
        "border-tertiary-bg",
        "border-tertiary-bg-strong",

        // Grayscale borders
        "border-grayscale",
        "border-grayscale-weak",
        "border-grayscale-label",
        "border-grayscale-input",
        "border-grayscale-placeholder",
        "border-grayscale-body",
        "border-grayscale-header-weak",
        "border-grayscale-line",

        // Status borders
        "border-success",
        "border-success-strong",
        "border-success-weak",
        "border-success-bg",
        "border-success-bg-strong",
        "border-warning",
        "border-warning-strong",
        "border-warning-weak",
        "border-warning-bg",
        "border-warning-bg-strong",
        "border-danger",
        "border-danger-strong",
        "border-danger-weak",
        "border-danger-bg",
        "border-danger-bg-strong",
      ],

      // Custom shadows
      shadow: [
        "shadow-elevation-1",
        "shadow-elevation-2",
        "shadow-elevation-3",
        "shadow-elevation-4",
        "shadow-elevation-5",
        "shadow-elevation-6",
        "shadow-elevation-7",
        "shadow-elevation-8",
        "shadow-elevation-9",
        "shadow-elevation-10",
        "shadow-course-card",
      ],

      // Custom sizes
      size: ["size-10.5"],

      // Custom width/height
      w: ["w-container-studyiq", "w-course-card"],

      "max-w": ["max-w-container-studyiq", "max-w-course-card"],

      h: ["h-container-studyiq", "h-course-card"],

      "max-h": ["max-h-container-studyiq", "max-h-course-card"],

      // Custom spacing
      p: ["p-2.25"],

      py: ["py-2.25"],

      px: ["px-2.25"],

      // Custom blur
      blur: ["blur-px"],

      // Custom aspect ratios
      aspect: ["aspect-video-course-card-thumbnail"],

      // Custom font family
      "font-family": ["font-lato"],
    },

    // Custom class groups for gradient utilities that don't conflict with standard classes
    conflictingClassGroups: {
      "bg-color": [
        "gradient-course-package-platinum",
        "gradient-course-package-gold",
        "gradient-course-package-silver",
        "gradient-instagram",
      ],
    },
  },
});

export default stiqTwMerge;
